
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.838 18.369"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M9.191 10.333l.51-3.324H6.514V4.851a1.662 1.662 0 011.877-1.796h1.45V.225A17.684 17.684 0 007.264 0C4.638 0 2.92 1.592 2.92 4.475v2.533H0v3.324h2.92v8.036h3.594v-8.035z"}})])
          )
        }
      }
    